module.exports = __webpack_public_path__ + "fonts/FuturaNowText-Bd.c46dbb63.ttf";